import React from 'react'
import { isEmpty } from 'ramda'
import { Card } from '@ally/metronome-ui'
import useMboxCall from '@ally/use-mbox-call'
import { StatusTrackerActivity } from '@ally/shared-status-tracker'
import { useHostServices } from '../../HostServices'
import { fetchActivitiesData } from './tipsData'
import StatusTrackerTips from './StatusTrackerTips/StatusTrackerTips'
import { CreditCardTips } from './CreditCardTips'
import { filterActivities, sortActivities } from './utils'
import { verifyContent } from '../../utils'
import { statusTrackerAnalytics } from '../../analytics'
import TipsMbox from './TipsMbox'
import { useCreditCardOfferQuery } from '../../hooks'

export const TipsAndOpportunities: React.FC = () => {
  const [trackingFired, setTrackingFired] = React.useState(false)
  const [activities, setActivities] = React.useState<
    StatusTrackerActivity[] | []
  >([])
  const { session, featureFlags, analytics, log } = useHostServices()
  const { data } = useCreditCardOfferQuery()
  const customerCardOffer = data?.customerCardOffer
  const isCustomerCardOfferAvailable = customerCardOffer?.isOfferAvailable
  const showCreditCardOffer =
    isCustomerCardOfferAvailable &&
    !!customerCardOffer?.offerDetails?.productType

  const { loadState } = featureFlags
  const guid = session.data?.guid
  const accessToken = session.data?.access_token
  const isLoaded = loadState === 'loaded'

  React.useEffect(() => {
    if (isLoaded && guid && accessToken) {
      fetchActivitiesData({ guid, accessToken, featureFlags }).then(
        activitiesData => {
          const filteredActivities = filterActivities(activitiesData, log)
          const sortedActivities = sortActivities(filteredActivities)
          setActivities(sortedActivities.slice(0, 2))
        },
      )
    }
  }, [guid, accessToken, isLoaded])

  React.useEffect(() => {
    if (!trackingFired && analytics && activities.length) {
      statusTrackerAnalytics(analytics, activities)
      setTrackingFired(true)
    }
  }, [analytics, activities])

  const adobeTip1 = useMboxCall('ally-dashboard-tips-01', []).mboxData
  const adobeTip2 = useMboxCall('ally-dashboard-tips-02', []).mboxData
  const adobeTip3 = useMboxCall('ally-dashboard-tips-03', []).mboxData

  if (adobeTip1 && !isEmpty(adobeTip1)) {
    adobeTip1[0].trackingName = 'ally-dashboard-tips-01'
  }

  if (adobeTip2 && !isEmpty(adobeTip2)) {
    adobeTip2[0].trackingName = 'ally-dashboard-tips-02'
  }

  if (adobeTip3 && !isEmpty(adobeTip3)) {
    adobeTip3[0].trackingName = 'ally-dashboard-tips-03'
  }

  const tipArray = [adobeTip1, adobeTip2, adobeTip3]
  const filteredTips = tipArray.filter(tip => {
    try {
      return verifyContent(tip)
    } catch {
      // istanbul ignore next
      return false
    }
  })

  return (
    <>
      {activities.length > 0 ||
      filteredTips.length > 0 ||
      showCreditCardOffer ? (
        <Card closeButton={false}>
          {showCreditCardOffer && (
            <CreditCardTips customerCardOffer={customerCardOffer} />
          )}
          {filteredTips.length > 0 && <TipsMbox adobeTips={filteredTips} />}
          {activities.length > 0 && (
            <StatusTrackerTips activities={activities} />
          )}
        </Card>
      ) : null}
    </>
  )
}
